import gql from 'graphql-tag';

export const QueryCompensationGradesByCompanyId = gql`
	query QueryCompensationGradesByCompanyId($companyId: ID!) {
		queryCompensationGradesByCompanyId(companyId: $companyId) {
			compensationGrade
		}
	}
`;
